module.exports = __webpack_public_path__ + "static/workn-34a0e60f185f74c79a6fca4dbab54cc6.jpg";